export class Organization {
    
    organizationId:string;
    organizationname:string;
    orgdesc?:string;
    email?:string;
    www:string;
    address?:string;
    address2?:string;
    zip?:string;
    city?:string;
    country?:string;
    phone?:string;
    logourl?:string;

}